'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EvalQuery = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.evaluateQueryFragment = evaluateQueryFragment;

var _ValueSet = require('./ValueSet');

var _ValueSet2 = _interopRequireDefault(_ValueSet);

var _ValueSetRegistry = require('./ValueSetRegistry');

var _ValueSetRegistry2 = _interopRequireDefault(_ValueSetRegistry);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = (0, _debug2.default)('@complion:query:evaluateQueryFragment');

/**
 *   evaluateQueryFragment
 *      
 *   Replaces the value sets of the query with their selected values.
 *   Each valueSet will need to have a toQueryFragment function applied to it,
 *   which will then be used to provide the substituted value into the query.
 */
/**
 * Created by james on 5/9/2016.
 */

function evaluateQueryFragment(queryFragment, context) {
    var evaluation = new EvalQuery(queryFragment, context);
    evaluation.evaluate();
    return evaluation.queryFragment;
}

var EvalQuery = exports.EvalQuery = function () {
    function EvalQuery(queryFragment, context) {
        (0, _classCallCheck3.default)(this, EvalQuery);

        this.queryFragment = queryFragment;
        this.context = context;
    }

    (0, _createClass3.default)(EvalQuery, [{
        key: 'evaluate',
        value: function evaluate() {
            this.visitObject(this.queryFragment);
        }
    }, {
        key: 'visitObject',
        value: function visitObject(queryFragment) {
            var queryFragmentPiece;
            for (var prop in queryFragment) {
                /* istanbul ignore if  */
                if (prop === '_parentNode') {
                    //Avoid infinite loop with parentNode
                    continue;
                }
                queryFragmentPiece = queryFragment[prop];
                if (queryFragmentPiece instanceof _ValueSet2.default) {
                    try {
                        queryFragment[prop] = queryFragmentPiece.toQueryFragment(this.context);
                    } catch (error) {
                        debug(error);
                    }
                } else if ((typeof queryFragmentPiece === 'undefined' ? 'undefined' : (0, _typeof3.default)(queryFragmentPiece)) === 'object' && queryFragmentPiece !== null) {
                    if (queryFragmentPiece._isValueSet) {
                        try {
                            var evaluatedFragment = _ValueSetRegistry2.default.reconstituteDeserializedJson(queryFragmentPiece);
                            queryFragment[prop] = evaluatedFragment.toQueryFragment(this.context);
                        } catch (error) {
                            debug(error);
                        }
                    } else {
                        this.visitObject(queryFragmentPiece);
                    }
                }
            }
        }
    }]);
    return EvalQuery;
}();